import script from "./FeedsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedsPage.vue?vue&type=script&setup=true&lang=js"

import "./FeedsPage.vue?vue&type=style&index=0&id=3d415c9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d415c9d"]])

export default __exports__